import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface WaitStepEditorProps {
  days: number
  onChange: (days: number) => void
  onSave: () => void
  onCancel: () => void
  saving?: boolean
  saveLabel?: string
}

export function WaitStepEditor({
  days,
  onChange,
  onSave,
  onCancel,
  saving,
  saveLabel = 'Add',
}: WaitStepEditorProps) {
  return (
    <div className="flex items-end gap-2 rounded-md border p-3">
      <label className="flex flex-col gap-1 text-sm">
        Wait (days)
        <Input
          type="number"
          min={1}
          value={days}
          onChange={(e) => onChange(Math.max(1, Number(e.target.value)))}
          className="w-24"
        />
      </label>
      <Button onClick={onSave} disabled={saving} className="text-md">
        {saveLabel}
      </Button>
      <Button variant="ghost" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )
}
